@if (showLoader() && hasData) {
    <ms-component-loader />
}

@let banner = this.banner();
@if (hasData && banner && hideGamingCrossSellByArc() === false) {
    @if (ofType(banner, 'CasinoLink')) {
        <ds-card
            surface="lowest"
            msThemedCard
            class="card-alignment"
            [border]="false"
            [elevated]="true"
            [themeBorder]="themeBorder"
            [themeCardElevated]="themeElevated"
            [radius]="!(isMobile() && !isEpcotEnabled())">
            <ms-casino-banner-link [model]="banner" [position]="position" (bannerDataLoaded)="bannerDataLoaded($event)" />
        </ds-card>
    } @else if (ofType(banner, 'SportLink')) {
        <ds-card
            surface="lowest"
            msThemedCard
            class="card-alignment"
            [border]="false"
            [elevated]="true"
            [themeBorder]="themeBorder"
            [themeCardElevated]="themeElevated"
            [radius]="!(isMobile() && !isEpcotEnabled())">
            <ms-sport-banner-link [model]="banner" [position]="position" (bannerDataLoaded)="bannerDataLoaded($event)" />
        </ds-card>
    } @else if (ofType(banner, 'Jackpot')) {
        <ms-banner-jackpot [model]="banner" [position]="position" (bannerDataLoaded)="bannerDataLoaded($event)" />
    } @else if (ofType(banner, 'Games')) {
        <ds-card
            surface="lowest"
            class="card-alignment"
            msThemedCard
            [border]="false"
            [elevated]="true"
            [radius]="!(isMobile() && !isEpcotEnabled())"
            [themeCardElevated]="themeElevated"
            [themeBorder]="themeBorder">
            <ms-banner-games [model]="banner" [position]="position" (bannerDataLoaded)="bannerDataLoaded($event)" />
        </ds-card>
    } @else if (ofType(banner, 'Vyml')) {
        <ds-card
            surface="lowest"
            class="card-alignment"
            msThemedCard
            [border]="false"
            [elevated]="true"
            [radius]="!(isMobile() && !isEpcotEnabled())"
            [themeCardElevated]="themeElevated"
            [themeBorder]="themeBorder">
            <ms-vyml [model]="banner" [position]="position" (bannerDataLoaded)="bannerDataLoaded($event)" />
        </ds-card>
    } @else if (ofType(banner, 'Esport')) {
        <ds-card msThemedCard noOverflow surface="lowest" [border]="false" [elevated]="true" [themeCardElevated]="themeElevated">
            <ms-banner-esport [model]="banner" (bannerDataLoaded)="bannerDataLoaded($event)" />
        </ds-card>
    }
}
